import { faCircleDot } from '@fortawesome/free-regular-svg-icons/faCircleDot'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import controlStore from '../../../store/controlStore.ts'
import { centerMapOnPets } from '../../map/mapHelpers.tsx'
import historyStore from '../../../store/historyStore.ts'

interface Props {
    history?: boolean
}

export const CenterMapButton: React.FC<Props> = (props) => {
    const { history } = props
    const isOnMobile = controlStore(s => s.isOnMobileDevice)
    const selectedPetId = historyStore(s => s.selectedPetId)
    const disabled = history ? !selectedPetId : false
    const size = isOnMobile ? '3x' : 'xl'

    return (
        <div onClick={() => centerMapOnPets(history, disabled)} className={'w-fit h-fit cursor-pointer'}>
            <FontAwesomeIcon icon={faCircleDot} size={size} color={disabled ? 'gray' : 'black'}/>
        </div>
    )
}
